export default __webpack_public_path__ + "static/media/p24.8201de29.jpg";